/**
 * @generated SignedSource<<357ec52c93a85365f801d4f74701c98c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type issueSearch_issueNavigatorProject$data = {
  readonly projectId?: string | null | undefined;
  readonly " $fragmentType": "issueSearch_issueNavigatorProject";
};
export type issueSearch_issueNavigatorProject$key = {
  readonly " $data"?: issueSearch_issueNavigatorProject$data;
  readonly " $fragmentSpreads": FragmentRefs<"issueSearch_issueNavigatorProject">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesdogfoodingenabledrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "issueSearch_issueNavigatorProject",
  "selections": [
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesdogfoodingenabledrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "projectId"
        }
      ]
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "6a2aab5ab5f6ad8d0e23c840e0239294";

export default node;
